import React, { Component } from 'react'
import styles from './Input.module.scss';
import classNames from 'classnames/bind';
import {ErrorIcon} from '../../atoms';

const cx = classNames.bind(styles);

class Input extends Component {
  state = {
    isBlur: true
  }

  onBlur = (e) => {
    this.props.onBlur(e);
    this.setState({isBlur: true});
  }

  onFocus = () => {
    this.setState({isBlur: false});
  }

  render() {
    const { type, name, value, placeholder, className, onChange, isError } = this.props;
    const {onBlur, onFocus} = this;
    const {isBlur} = this.state;
    return (
      <div className={cx('Input-wrapper')}>
        <input
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          placeholder={placeholder}
          className={`${cx('Input', !isBlur && 'Input--typed', isError && 'Input--error')} ${className}`}
        />
        <ErrorIcon className={cx('Input__error-icon', isError && 'Input__error-icon--show')}/>
      </div>
    )
  }
}

Input.defaultProps = {
  type: 'text',
  name: '',
  placeholder: '',
  className: ''
};

export default Input;
